import React from 'react'
import { Modal, Table, Badge } from 'react-bootstrap';

const ViewRecordObjectData = (props) => {
    const toggle = () => {
        props?.close?.();
    };

    const record = props?.activeModelRecordData;

    // Helper function to render nested object values
    const renderNestedValue = (value, key) => {
        if (value === null || value === undefined) {
            return <span className="text-muted">null</span>;
        }
        
        if (Array.isArray(value)) {
            return (
                <div>
                    <Badge bg="info" className="mb-2">Array ({value.length} items)</Badge>
                    <pre className='m-0' style={{ fontSize: '0.875rem', maxHeight: '200px', overflow: 'auto' }}>
                        {JSON.stringify(value, null, 2)}
                    </pre>
                </div>
            );
        }
        
        if (typeof value === "object") {
            return (
                <div>
                    <Badge bg="primary" className="mb-2">Object</Badge>
                    <pre className='m-0' style={{ fontSize: '0.875rem', maxHeight: '200px', overflow: 'auto' }}>
                        {JSON.stringify(value, null, 2)}
                    </pre>
                </div>
            );
        }
        
        if (typeof value === "boolean") {
            return (
                <Badge bg={value ? "success" : "secondary"}>
                    {value ? "Yes" : "No"}
                </Badge>
            );
        }
        
        return <span>{String(value)}</span>;
    };

    return (
        <Modal show={props?.showModel} onHide={toggle} size="lg">
            <Modal.Header style={{ borderBottom: "none" }} closeButton>
                <Modal.Title>{props?.title || "Record Details"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {record ? (
                    <Table striped bordered hover size="sm">
                        <tbody>
                            {Object.entries(record || {})?.map(([key, value]) => (
                                <tr key={key}>
                                    <td className='p-2' style={{ width: '30%' }}>
                                        <strong>{key}</strong>
                                    </td>
                                    <td className='p-2'>
                                        {renderNestedValue(value, key)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ) : (
                    <p>No data available</p>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default ViewRecordObjectData;
